import { message, notification } from "antd";
import {
  APIResponseStatus,
  ServiceOfferingActions,
} from "../Constants/Constants";
import { convertServiceOfferingFormToApiValues } from "../Helpers/ServiceOfferingHelpers";
import { apiCallback } from "./Common";

const getMessage = (action, success) => {
  if (success) {
    return `Service offering ${
      action === ServiceOfferingActions.add ? "added" : "updated"
    } successfully!`;
  }
  return `Error ${
    action === ServiceOfferingActions.add ? "adding" : "updating"
  } service offering`;
};

export const onFormSubmit =
  ({ props, setProcessing, setInitialValues }) =>
  (values) => {
    const { action, serviceOfferingApi } = props;
    console.log("form onSubmit", values, props);
    const failMessage = getMessage(action, false);
    const successMsg = getMessage(action, true);
    const formSubmitCallback = apiCallback({
      history: props.history,
      preProcess: () => setProcessing(false),
      errorCallback: () => message.error(failMessage),
      successCallback: (data) => {
        if (data.status === APIResponseStatus.fail) {
          if (data.info === "ExistingServiceOffer") {
            notification["error"]({
              message: "Error creating Service Offering",
              description: `Service Offering name already exist.`,
            });
          } else {
            message.error(failMessage);
          }
        } else {
          setInitialValues(values);
          message.success(successMsg);
          props.onSubmit({ redirect: action === ServiceOfferingActions.add });
        }
      },
    });
    try {
      setProcessing(true);
      values.offerid = props.record?.offerid;
      values.serviceid = props.record?.serviceid;
      values.instanceid = props.record?.instanceid;
      const formattedData = convertServiceOfferingFormToApiValues(
        values,
        props.action
      );
      console.log("onSubmit formattedData", formattedData);
      if (action === ServiceOfferingActions.add) {
        serviceOfferingApi.addServiceOffering(
          formattedData,
          formSubmitCallback
        );
      } else {
        serviceOfferingApi.updateServiceOffering(
          formattedData,
          formSubmitCallback
        );
      }
    } catch (error) {
      message.error(failMessage);
      setProcessing(false);
    }
  };
